import { useContext } from "react"
import { Stack, Typography } from "@mui/material"
import { ToolContext } from "../../../../../../core/context/ToolContext"
import { StndrdTextField } from "../../../../../../core/styling/form/CstmField"

export const Details = ({ handleChange }) => {
    const { marketing_camp } = useContext(ToolContext)
    const { trngForm } = marketing_camp

    return (
        <Stack width='100%' mt='1rem' gap='1.5rem'>
            <Stack gap='0.5rem' width='100%'>
                <Stack direction='row' gap='4px'>
                    <Typography fontWeight={600}>Poster Name</Typography>
                    <Typography fontWeight={600} sx={{ color: '#E34935' }}>*</Typography>
                </Stack>
                <StndrdTextField name='poster_name' value={trngForm.data?.poster_name?.value} onChange={handleChange} size='small' fullWidth error={trngForm.data?.poster_name?.stat || trngForm.data.poster_name.value.trim() === ''} multiline inputProps={{ style: { maxHeight: "15rem" } }}/>
            </Stack>
        </Stack>
    )
}
